import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { api } from '../utils/api';
import ReelPlayer from '../components/ReelPlayer';
import { ArrowLeft } from 'lucide-react';
import { Button } from '../components/ui/button';

export default function SingleReel() {
  const { reelId } = useParams();
  const [reel, setReel] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchReel();
  }, [reelId]);

  const fetchReel = async () => {
    try {
      const response = await api.get(`/reels/${reelId}`);
      setReel(response.data);
    } catch (error) {
      console.error('Failed to fetch reel:', error);
      setError('Reel not found');
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="h-screen w-screen flex items-center justify-center bg-black">
        <div className="text-white text-xl">Loading...</div>
      </div>
    );
  }

  if (error || !reel) {
    return (
      <div className="h-screen w-screen flex flex-col items-center justify-center bg-black text-white p-8">
        <h2 className="text-2xl font-bold mb-4">Reel Not Found</h2>
        <p className="text-gray-400 mb-8">{error || 'This reel may have been removed'}</p>
        <Button onClick={() => window.history.back()}>
          <ArrowLeft className="h-4 w-4 mr-2" />
          Go Back
        </Button>
      </div>
    );
  }

  return (
    <div className="h-screen w-screen bg-black relative">
      {/* Back button */}
      <div className="absolute top-4 left-4 z-50">
        <Button
          size="icon"
          variant="ghost"
          className="rounded-full bg-black/30 text-white hover:bg-black/50"
          onClick={() => window.history.back()}
        >
          <ArrowLeft className="h-5 w-5" />
        </Button>
      </div>

      <ReelPlayer reel={reel} isActive={true} />
    </div>
  );
}
